import type { WizardStep } from '../providers/WizardStepsContext';

export const links: WizardStep[] = [
	{
		key: 'general',
		title: 'General Info',
		link: 'general',
	},
	{
		key: 'users',
		title: 'User Info',
		link: 'users',
	},
	{
		key: 'settings',
		title: 'Configure Settings',
		link: 'settings',
	},
	{
		key: 'summary',
		title: 'Summary',
		link: 'summary',
		action: 'Create Organization',
	},
];
